<template>
    <div id="reports_wrapper">
        <div class="sansation mt-8 mb-4 info--text mx-4">

            <h2>EMP Reports</h2>

            <!-- <v-card flat 
                color="pewter"
                class="my-2 pa-2 d-flex">
                    <v-radio-group row
                        v-model="show_report">
                        <v-radio
                            label="No Interest Buyers"
                            value="no_interest"
                            color="primary darken-1">
                        </v-radio>

                        <v-radio
                            label="Search Buyers"
                            value="search_buyers"
                            color="primary darken-1">
                        </v-radio>
                        <v-radio
                            label="EMP Status"
                            value="emp_status"
                            color="primary darken-1">
                        </v-radio>
                    </v-radio-group>
            </v-card> -->
        </div>

        <EMPStatus 
            v-if="show_report == 'emp_status'"
            @triggerUserFeedback="triggerUserFeedback" />
    </div>
</template>

<script>

    import EMPStatus from './reports/EMPStatus'

    export default {
        components: {
            EMPStatus,
        },

        data: () => ({

            show_report: 'emp_status'
        }),

        created () {
            document.title = `EMP Reports`;
        },

        methods: {
            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #reports_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/ReportsEMP.vue